<ion-header>
  <ion-toolbar>
    <ion-title>Átemelés az órarendbe</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="bezar()"><ion-icon slot="icon-only" name="close"></ion-icon></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div *ngIf="toltodik" class="tko-uzenet"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>

  <ng-container *ngIf="!toltodik && allapot">
    <ion-note color="medium" class="tko-blokk">
      A <b>{{ allapot.esemeny?.nev }}</b> jelentkezőiből <b>nem tanórai célú</b> csoport lesz, a megadott
      heti időpontokra pedig órák kerülnek az órarendbe – mint egy rendes szakkörnél. A szülő a nem tanórai
      foglalkozás hiányzását alapból nem látja, és a KRÉTA-átvitel sem viszi át.
    </ion-note>

    <div class="tko-jelentkezok">
      <b>{{ allapot.tanulok_db }}</b> jelentkezett tanuló
      <span *ngIf="allapot.kulsos_db"> · {{ allapot.kulsos_db }} külsős résztvevő (ők nem kerülnek a csoportba)</span>
      <span *ngIf="allapot.ismeretlen_db"> · {{ allapot.ismeretlen_db }} nem azonosítható</span>
    </div>
    <ion-note color="primary" *ngIf="allapot.korabbi" class="tko-blokk">
      Ezt a foglalkozást már átemelték ({{ allapot.korabbi.modositva || allapot.korabbi.letrehozva | date:'yyyy. MM. dd.' }}).
      Az újabb átemelés <b>nem hoz létre új csoportot</b>: besorolja az azóta jelentkezetteket, lezárja a
      visszalépettek tagságát, és pótolja a hiányzó órákat. Meglévő órát nem töröl.
    </ion-note>

    <ion-list>
      <ion-item>
        <ion-input label="Csoport neve" labelPlacement="stacked" [(ngModel)]="f.nev" (ngModelChange)="valtozott()" maxlength="180"></ion-input>
      </ion-item>
      <ion-item>
        <ion-select label="Tantárgy" labelPlacement="stacked" interface="popover" [(ngModel)]="f.tantargy" (ionChange)="valtozott()">
          <ion-select-option *ngFor="let t of tantargyak" [value]="t.id">{{ t.name }}{{ t.szakkor == 1 ? ' (szakkör)' : '' }}</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-input label="Tanár keresése" labelPlacement="stacked" placeholder="név részlete" [(ngModel)]="tanarSzuro"></ion-input>
      </ion-item>
      <ion-item>
        <ion-select label="Tartja" labelPlacement="stacked" interface="popover" [(ngModel)]="f.tanar" (ionChange)="valtozott()">
          <ion-select-option *ngFor="let m of szurtMunkatarsak" [value]="m.adid">{{ m.nev }}</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-select label="Terem" labelPlacement="stacked" interface="popover" [(ngModel)]="f.terem" (ionChange)="valtozott()">
          <ion-select-option *ngFor="let t of termek" [value]="t.id">{{ t.name }}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-list-header><ion-label>Heti időpontok</ion-label></ion-list-header>
      <ion-item *ngFor="let i of f.idopontok; let ix = index">
        <ion-select label="Nap" labelPlacement="stacked" interface="popover" [(ngModel)]="i.nap" (ionChange)="valtozott()">
          <ion-select-option *ngFor="let n of NAPOK" [value]="n.n">{{ n.nev }}</ion-select-option>
        </ion-select>
        <ion-input label="Óra" labelPlacement="stacked" type="number" min="0" max="12" [(ngModel)]="i.ora" (ngModelChange)="valtozott()"></ion-input>
        <ion-input label="Hossz (óra)" labelPlacement="stacked" type="number" min="1" max="4" [(ngModel)]="i.hossz" (ngModelChange)="valtozott()"></ion-input>
        <ion-button slot="end" fill="clear" color="danger" (click)="idopontTorol(ix)" [disabled]="f.idopontok.length < 2" title="Időpont törlése">
          <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
        </ion-button>
      </ion-item>
      <ion-button fill="clear" size="small" (click)="idopontUj()"><ion-icon slot="start" name="add"></ion-icon> Időpont hozzáadása</ion-button>

      <ion-item>
        <ion-input label="Első nap" labelPlacement="stacked" type="date" [(ngModel)]="f.tol" (ngModelChange)="valtozott()"></ion-input>
        <ion-input label="Utolsó nap (üresen: tanév vége)" labelPlacement="stacked" type="date" [(ngModel)]="f.ig" (ngModelChange)="valtozott()"></ion-input>
      </ion-item>
      <ion-item>
        <ion-checkbox [(ngModel)]="f.oraszamba" (ionChange)="valtozott()" labelPlacement="end">
          Beleszámít a tanár óraszámába
        </ion-checkbox>
      </ion-item>
      <ion-note color="medium" class="tko-blokk">
        Ha nincs bepipálva, a csoport órái kimaradnak a havi óraszám-kimutatásból és a tantárgyfelosztás
        órarendből építéséből, a munkaidő-elszámolásban pedig külön táblában látszanak, a Mindösszesenen kívül.
      </ion-note>
    </ion-list>

    <ion-note color="danger" *ngIf="hiba" class="tko-blokk">{{ hiba }}</ion-note>

    <div class="tko-elonezet" *ngIf="elonezet && !kesz">
      <b>Előnézet – még semmi nem változott</b>
      <div>{{ elonezet.csoport_uj ? 'Új csoport' : 'Meglévő csoport' }}: <b>{{ elonezet.nev }}</b> ({{ elonezet.tantargy_nev }})</div>
      <div>Időszak: {{ elonezet.tol }} – {{ elonezet.ig }} · első óra: {{ elonezet.elso || '—' }}</div>
      <div>Új óra: <b>{{ elonezet.orak_uj }}</b><span *ngIf="elonezet.orak_megvolt"> · már megvolt: {{ elonezet.orak_megvolt }}</span></div>
      <div>Tanulók: <b>{{ elonezet.tagok_osszes }}</b> (új: {{ elonezet.tagok_uj }}<span *ngIf="elonezet.tagok_kilep">, kilép: {{ elonezet.tagok_kilep }}</span>)</div>
      <div>Óraszámba: {{ elonezet.oraszamba ? 'beleszámít' : 'nem számít bele' }}</div>
      <div *ngIf="elonezet.utkozik?.length" class="tko-utkozes">
        {{ elonezet.utkozik.length }} alkalom kimarad, mert a tanárnak akkor már van órája:
        {{ utkozesSzoveg() }}
      </div>
    </div>

    <div class="tko-elonezet kesz" *ngIf="kesz">
      <b>Kész.</b> {{ kesz.orak_uj }} új óra került az órarendbe, {{ kesz.tagok_uj }} tanuló került a csoportba<span *ngIf="kesz.tagok_kilep">, {{ kesz.tagok_kilep }} tagsága lezárult</span>.
    </div>
  </ng-container>
</ion-content>

<ion-footer *ngIf="!toltodik && allapot">
  <ion-toolbar>
    <div class="tko-gombok">
      <ion-button fill="outline" (click)="elonezetKer()" [disabled]="fut || !!kesz">
        <ion-spinner *ngIf="fut && !elonezet" name="dots"></ion-spinner> Előnézet
      </ion-button>
      <ion-button color="primary" (click)="atemel()" [disabled]="fut || !elonezet || !!kesz || (!elonezet.orak_uj && !elonezet.tagok_uj && !elonezet.tagok_kilep)">
        Átemelés az órarendbe
      </ion-button>
      <ion-button fill="clear" color="medium" (click)="bezar()">{{ kesz ? 'Bezárás' : 'Mégse' }}</ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
